import { Flex, Text, Input, Spinner, InputProps } from '@chakra-ui/react';
import { FC, useState } from 'react';
import useDebounce from '../../../hooks/useDebounce';

type SearchInputProps = {
  onSearch: (search: string) => Promise<void>;
  activeDebounce?: boolean;
  label?: string;
  isSearching?: boolean;
};

const SearchInput: FC<SearchInputProps & InputProps> = ({
  onSearch,
  activeDebounce,
  label,
  isSearching,
  ...rest
}) => {
  const { debounce } = useDebounce();
  const [isTyping, setIsTyping] = useState(false);

  const handleSearch = (value: string) => {
    setIsTyping(true);
    if (activeDebounce) {
      debounce(() => onSearch(value).finally(() => setIsTyping(false)), 500);
    } else {
      onSearch(value).finally(() => setIsTyping(false));
    }
  };
  return (
    <Flex alignItems="center" gridGap="2">
      {label && (
        <Text as="label" size="sm">
          {label}
        </Text>
      )}
      <Input
        placeholder="Digite sua busca"
        size="sm"
        rounded="base"
        maxW="256px"
        {...rest}
        onChange={e => handleSearch(e.target.value)}
      />
      {isSearching || isTyping ? (
        <Spinner
          thickness="2px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="sm"
        />
      ) : undefined}
    </Flex>
  );
};

export default SearchInput;
